import { network } from 'services/network';

export const getAllUserGroups = ({ isProjectCreation }) => {
    return network.post('admin/bo/getAllUserGroups', { isProjectCreation }).then((response) => response.data);
};
